/* @flow */

import * as types from './marketActionTypes';
import { featuredFiltersEndpoint } from 'src/shared/app/base/settings/endpointSettings';
import { patchMembership } from 'src/shared/domain/membership/action/membershipActions';

export function setMarketStatusFilter(value: string) {
  return {
    type: types.SET_MARKET_STATUS_FILTER,
    value,
  };
}

export function resetMarketStatusFilter() {
  return {
    type: types.RESET_MARKET_STATUS_FILTER,
  };
}

export function setMarketKindFilter(value: string) {
  return {
    type: types.SET_MARKET_KIND_FILTER,
    value,
  };
}

export function resetMarketKindFilter() {
  return {
    type: types.RESET_MARKET_KIND_FILTER,
  };
}

export function setMarketLanguageFilter(value: string) {
  return {
    type: types.SET_MARKET_LANGUAGE_FILTER,
    value,
  };
}

export function resetMarketLanguageFilter() {
  return {
    type: types.RESET_MARKET_LANGUAGE_FILTER,
  };
}

export function resetMarketFilters() {
  return {
    type: types.RESET_MARKET_FILTERS,
  };
}

export function setMarketSortOrdering(value: string) {
  return {
    type: types.SET_MARKET_SORT_ORDERING,
    value,
  };
}

export function resetMarketSortOrdering() {
  return {
    type: types.RESET_MARKET_SORT_ORDERING,
  };
}

export function setMarketQuery(value: string) {
  return {
    type: types.SET_MARKET_QUERY,
    value,
  };
}

export function setMarketQueryContext(context: string) {
  return {
    type: types.SET_MARKET_QUERY_CONTEXT,
    context,
  };
}

export function resetMarketQuery() {
  return {
    type: types.RESET_MARKET_QUERY,
  };
}

export function invalidateMarket() {
  return {
    type: types.INVALIDATE_MARKET,
  };
}

export function completeFavoriteTutorial(eventId: number) {
  return patchMembership(eventId, {
    flags: {
      favorite_tutorial_completed: true,
    },
  });
}

// Featured

export function fetchFeaturedFilters(eventId: number, language: string) {
  return (dispatch: any, { smartGet }: Object) => {
    dispatch(fetchFeaturedFiltersRequest());

    return smartGet(featuredFiltersEndpoint(eventId), { language })
      .then((json) => dispatch(fetchFeaturedFiltersSuccess(json)))
      .catch((exception) => {
        dispatch(fetchFeaturedFiltersFailure(exception));

        throw exception;
      });
  };
}

export function fetchFeaturedFiltersRequest() {
  return {
    type: types.FETCH_FEATURED_FILTERS_REQUEST,
  };
}

export function fetchFeaturedFiltersSuccess(result: Array<string>) {
  return {
    type: types.FETCH_FEATURED_FILTERS_SUCCESS,
    result,
  };
}

export function fetchFeaturedFiltersFailure(exception: Error) {
  return {
    type: types.FETCH_FEATURED_FILTERS_FAILURE,
    exception,
  };
}
